import { parse } from 'csv-parse/browser/esm/sync';
import { UploadWorkflowContact } from 'services/api/postUploadWorkflowContacts';

const stringHeaders = ['firstName', 'lastName', 'phoneNumber', 'crmStatus', 'crmId', 'planName'] as const;
const jsonHeaders = ['dependents', 'metadata'] as const;
const allHeaders = [...stringHeaders, ...jsonHeaders] as const;

type AllHeader = (typeof allHeaders)[number];

export const parseCSV = (csvText: string) => {
    const records = parse(csvText, {
        columns: true,
        skip_empty_lines: true,
        trim: true,
        relax_quotes: true,
        relax_column_count: true,
    }) as Record<string, string>[];

    const headers = Object.keys(records[0] || {});
    const requiredHeaders = ['firstName', 'lastName', 'phoneNumber'] as (keyof UploadWorkflowContact)[];
    const missingHeaders = requiredHeaders.filter((header) => !headers.includes(header));

    const contacts: UploadWorkflowContact[] = [];
    let invalidPhoneCount = 0;
    const invalidPhonesData: { phoneNumber: string; name: string }[] = [];
    const jsonErrors: { row: number; column: string; error: string }[] = [];

    for (let i = 0; i < records.length; i++) {
        const record = records[i];
        const contact: UploadWorkflowContact = {
            firstName: '',
            lastName: '',
            phoneNumber: '',
        };

        for (const header of headers) {
            if (!allHeaders.includes(header as AllHeader)) continue;
            const value = record[header] || '';
            if (!value) continue;

            if ((stringHeaders as readonly string[]).includes(header)) {
                (contact as unknown as Record<string, unknown>)[header] = value;
            } else if (header === 'dependents') {
                try {
                    contact.dependents = JSON.parse(value);
                } catch {
                    jsonErrors.push({ row: i + 2, column: 'dependents', error: 'Invalid JSON in dependents column' });
                }
            } else if (header === 'metadata') {
                try {
                    contact.metadata = JSON.parse(value);
                } catch {
                    jsonErrors.push({ row: i + 2, column: 'metadata', error: 'Invalid JSON in metadata column' });
                }
            }
        }

        if (
            contact.phoneNumber &&
            (!contact.phoneNumber.startsWith('+1') || contact.phoneNumber.replace(/\D/g, '').length !== 11)
        ) {
            invalidPhonesData.push({
                phoneNumber: contact.phoneNumber,
                name: `${contact.firstName} ${contact.lastName}`,
            });
            invalidPhoneCount++;
        } else {
            contacts.push(contact);
        }
    }

    return { contacts, invalidPhoneCount, invalidPhonesData, missingHeaders, jsonErrors };
};
